import VinculosEncerradosRedesign from "@/components/consignado/Cobranca/VinculosEncerradosRedesign";

// Tela "Vínculos Encerrados" (redesign). Query, filtros e paginação vivem no
// componente, como em Vínculos Ativos.
export default function VinculosEncerradosPage() {
  return <VinculosEncerradosRedesign />;
}
